import { render } from "./SearchResultsCompany.vue?vue&type=template&id=f2a73de4&scoped=true"
import script from "./SearchResultsCompany.vue?vue&type=script&lang=js"
export * from "./SearchResultsCompany.vue?vue&type=script&lang=js"

import "./SearchResultsCompany.vue?vue&type=style&index=0&id=f2a73de4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a73de4"]])

export default __exports__